// extracted by mini-css-extract-plugin
export default {"resendCode":"resendCode--D2tqv","disabled":"disabled--D8QMo"};